<template>
  <section :id="categoryUid" :class="$style.container">
    <Wrapper :class="$style.inner">
      <div :class="$style.header">
        <h2 :class="$style.title">
          {{ $t('AdviceHub.ArticleList.title', { value: categoryName }) }}
        </h2>
        <LkButton
          :href="categoryLink"
          :class="[$style.button, $style.desktopButton]"
          is-secondary
        >
          {{ $t('AdviceHub.ArticleList.seeAll', { value: categoryName }) }}
        </LkButton>
      </div>
      <div data-aos="fade-up">
        <div :class="$style.categoryList">
          <template v-for="(article, articleIndex) in category.articles">
            <ArticleThumbnail
              v-if="articleIndex < 3"
              :key="article.uid"
              :article="article"
              :class="$style.article"
            />
          </template>
        </div>
        <LkButton
          :href="categoryLink"
          :class="[$style.button, $style.mobileButton]"
          is-secondary
        >
          {{ $t('AdviceHub.ArticleList.seeAll', { value: categoryName }) }}
        </LkButton>
      </div>
    </Wrapper>
  </section>
</template>

<script>
import { getFormatedLink } from '~/mixins/getFormatedLink'
import ArticleThumbnail from '~/components/ArticleThumbnail'

export default {
  name: 'ArticlesList',

  components: {
    ArticleThumbnail,
  },

  mixins: [getFormatedLink],

  props: {
    category: {
      type: Object, // { categoryId: String, articles: Array }
      required: true,
    },
  },

  computed: {
    categoryName() {
      return this.$store.state.adviceCategoryData[this.category.categoryId]
        .category_name
    },

    categoryLink() {
      const categoryUid =
        this.$store.state.adviceCategoryData[this.category.categoryId].uid
      return this.getFormatedLink({
        link_type: 'Document',
        uid: categoryUid,
        type: 'advices_category_page',
        lang: this.$i18n.localeProperties.prismicIso.toLowerCase(),
      })
    },

    categoryUid() {
      return this.$store.state.adviceCategoryData[this.category.categoryId].uid
    },
  },
}
</script>

<style lang="scss" module>
.container {
  margin: 80px 0;
  padding: 80px 24px;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.title {
  @include typo-extra-title;
  font-weight: 200;
}

.button {
  padding: 8px 16px;

  @include typo-sub-text;

  &.mobileButton {
    width: 100%;
    margin-top: 40px;

    @include typo-body;

    @include above(medium) {
      display: none;
    }
  }

  &.desktopButton {
    display: none;
    @include above(medium) {
      display: block;
    }
  }
}

.categoryList {
  display: grid;
  gap: 40px;
  margin-top: 24px;

  @include above(small) {
    grid-template-columns: repeat(2, 1fr);
  }
  @include above(medium) {
    grid-template-columns: repeat(3, 1fr);
  }
}

.article {
  flex-basis: 33%;
}
</style>
